import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import ContentLayout from './ContentLayout';


import Links from './Links';

const earlyBearerColumns = [
  { key: 'period', label: 'Period' },
  { key: 'yorkshire', label: 'West Riding of Yorkshire' },
  { key: 'lancashire', label: 'Lancashire' },
  { key: 'cheshire', label: 'Cheshire' },
];

const earlyBearerRows = [
  {
    period: '14th\u201416th century',
    yorkshire: [
      'Thomas de Malgum',
      'Thomas de Malghom',
      'Stephen de Malgham',
      'William de Malghome',
      'William de Mallum',
      'Adam de Mallom',
      'William Malhum',
      'John Malum',
    ],
    lancashire: [],
    cheshire: [],
  },
  {
    period: '16th century',
    yorkshire: [],
    lancashire: ['Izabella Mallam', 'Marie Mallome'],
    cheshire: [],
  },
  {
    period: '16th\u201417th century',
    yorkshire: ['Anthonius Malham', 'Debora Mallham', 'John Maleham'],
    lancashire: [],
    cheshire: [],
  },
  {
    period: '17th century',
    yorkshire: [],
    lancashire: ['Henry Malham', 'Stephen Mallam'],
    cheshire: ['Ellen Malum', 'Elyn Malam', 'Mary Malam'],
  },
];

const censusYears = ['1841', '1851', '1861', '1871', '1881', '1891', '1901', '1911', '1921'];
const censusTotals = [208, 224, 191, 253, 273, 293, 339, 434, 429];
const countyCensusSeries = [
  { name: 'Cheshire', color: '#d9a63b', values: [84, 82, 79, 93, 130, 130, 122, 154, 154] },
  { name: 'Yorkshire', color: '#4f9aad', values: [14, 13, 22, 11, 20, 31, 34, 37, 40] },
  { name: 'Lancashire', color: '#c95f5f', values: [0, 2, 15, 16, 40, 55, 55, 61, 64] },
  { name: 'Lincolnshire', color: '#8aac62', values: [54, 43, 26, 47, 31, 14, 19, 22, 23] },
];
const censusSeries = [
  ...countyCensusSeries,
  {
    name: 'Other indexed areas',
    color: '#526f8d',
    values: censusTotals.map((total, index) => (
      total - countyCensusSeries.reduce((sum, series) => sum + series.values[index], 0)
    )),
  },
];
const censusChartMax = Math.ceil(Math.max(...censusTotals) / 100) * 100;
const censusPeakIndex = censusTotals.indexOf(Math.max(...censusTotals));
const censusIncrease = censusTotals[censusTotals.length - 1] - censusTotals[0];
const censusYearRange = `${censusYears[0]}\u2014${censusYears[censusYears.length - 1]}`;
const censusChartTicks = Array.from({ length: 5 }, (_, index) => (
  Math.round((censusChartMax / 4) * (4 - index))
));

function MalamFamilyHistory() {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const showDropdown = () => { setIsDropdownOpen(true); };
  const hideDropdown = () => { setIsDropdownOpen(false); };

  return (
    <ContentLayout
      title="Malam Family History"
      intro="Origins, pronunciation, and family stories from the Malam line."
      heroImage="/banners/family_banner.png"
    >
      <div className="content-body legacy-content-page">
        <div className="flex flex-row max-[768px]:bg-[#f8f7ff] text-[#1f1f1f]">

      <div className='max-[768px]:hidden w-[22rem]'>
        <Links />
      </div>

      <div className='flex flex-col'>
        <div className='flex flex-row justify-between'>
          <Link to="/" className='min-[768px]:hidden'>
            <svg className="mx-4 mt-6" id="text" width="140" viewBox="0 0 333 237" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M68 18.5C68.8922 18.5991 68.7432 20.401 68.75 21C68.7673 22.5226 68.9175 23.8936 69.1944 25.3889C69.3412 26.1812 69.7092 26.9417 70 27.6944C70.2932 28.4534 70.1441 29.173 70.3611 29.9444C72.4066 37.2174 72.9759 44.4699 73.625 52C73.9619 55.9082 74.1987 59.7174 74.8611 63.5972C75.3576 66.5054 75.1883 69.3425 75.2639 72.2917C75.3604 76.0551 75.909 79.7718 76.375 83.5C76.7815 86.7518 76.5 90.1659 76.5 93.4444C76.5 98.223 75.6301 104.417 71.3056 107.25C69.1246 108.679 65.5421 109.468 62.9444 109.5C59.3211 109.544 55.7202 109.522 52.1111 109.25C49.6857 109.067 47.4724 109.089 45.5972 107.458C43.591 105.714 43.4528 102.578 42.5 100.264C41.5475 97.9506 41.6873 95.5539 41.1111 93.1667C40.8002 91.8784 40.3134 90.7537 40 89.5M109.25 40.75C107.356 41.0943 104.629 43.5009 103.556 45C101.356 48.0728 99.1504 52.0771 98.0417 55.6806C97.1271 58.6528 97 61.9176 97 65C97 69.751 96.7191 74.4539 97.7222 79.1111C98.1355 81.03 98.1141 83.0148 98.5 84.9444C98.7698 86.2934 99.4318 87.5271 100.014 88.7639C100.838 90.5157 101.849 92.1882 103.194 93.5833C104.563 95.003 105.853 94.75 107.861 94.75C110.53 94.75 112.928 95.6268 115.194 93.75C117.847 91.5536 119.651 88.3755 120.75 85.1389C121.377 83.2937 121.743 81.4897 122.167 79.5972C122.689 77.2645 123.736 75.1626 124.111 72.7778C125.179 65.9802 125.36 58.2916 124.111 51.5139C123.342 47.3401 120.502 45.4889 117.611 42.75C115.46 40.712 113.324 40.75 110.5 40.75M143.5 15C143.5 16.3485 143.731 17.6492 143.75 19C143.768 20.2482 144.096 21.4528 144.194 22.6944C144.306 24.1089 144.169 25.5324 144.306 26.9444C144.556 29.5405 145 32.0206 145 34.6389V44.1111C145 50.9559 145.442 57.7282 145.5 64.5556C145.524 67.3955 146.013 70.3294 146.48 73.1328L146.5 73.25C146.924 75.7967 146.669 78.3735 147.056 80.8889C147.863 86.1373 147 91.6297 147 96.8889C147 97.3908 147.204 96.2717 147.25 96.1389C147.712 94.801 148.356 93.5622 148.75 92.1944C149.685 88.9466 150.703 86.0684 152.444 83.1667C153.382 81.6042 154.422 80.1921 155 78.4444C155.515 76.886 156.032 75.6191 156.944 74.25C158.757 71.5308 159.304 68.1586 161.097 65.4306C162.357 63.5129 162.927 61.1593 164.375 59.3889C166.03 57.3662 167.322 55.0648 169.111 53.1528C170.919 51.2205 172.468 48.8488 175 47.7639C176.82 46.9839 179.342 46.2393 181.361 46.7778C183.816 47.4323 185.701 50.239 186.861 52.25C189.269 56.4235 191.727 61.3183 191.986 66.2361C192.139 69.1451 192.5 71.9523 192.5 74.8889V84.5556C192.5 88.5374 193.25 92.5224 193.25 96.5C193.25 97.5415 193.5 98.5581 193.5 99.6111C193.5 101.027 194.003 100.144 194.5 99.25M213 35C213.988 35.1098 214.44 39.2519 214.556 40.1667C215.088 44.371 216.4 48.3885 217.111 52.5278C217.575 55.2243 217.624 57.9182 218.25 60.5972C219.022 63.8987 219.698 67.0932 219.75 70.5C219.833 75.9121 221.5 81.2139 221.5 86.5972C221.5 89.3439 222.25 91.9867 222.25 94.7222C222.25 95.6613 222.476 98.8138 222.5 95.8889C222.528 92.5498 223.382 89.4448 224.056 86.1944C224.968 81.7887 225.466 77.1218 227.014 72.8889C229.212 66.8757 231.583 60.9636 233.75 54.9444C235.058 51.3121 237.361 48.0133 239.5 44.8056C241.273 42.1458 243.683 40.4873 245.972 38.3889C247.703 36.8027 248.965 36.6412 251.25 37C254.815 37.5598 259.348 38.8616 260.125 42.9167C261.139 48.2101 261 53.4973 261 58.8611C261 64.2454 261.25 69.6135 261.25 75V88.5C261.25 91.4691 261.721 94.8651 261 97.75M22 218.75C22 216.974 22.4022 215.325 22.5972 213.569C22.9328 210.549 22.6977 207.476 22.75 204.444C22.8097 200.982 23.4752 197.53 23.625 194.056C23.7713 190.662 23.75 187.271 23.75 183.875V153.139C23.75 150.125 24 147.13 24 144.125C24 140.748 23.5 137.423 23.5 134.056V130.861C23.5 130.629 23.3692 129.047 23.4028 129.069C23.7269 129.285 23.953 129.918 24.1111 130.222C24.876 131.696 25.6748 133.146 26.5556 134.556C28.5239 137.705 30.8112 140.656 32.8333 143.778C35.7763 148.321 38.5089 152.853 41.1667 157.556C42.2018 159.387 43.5619 160.784 44.375 162.764C45.1516 164.655 45.5263 166.821 46.5139 168.611C47.6945 170.751 48.0517 173.156 49.3056 175.306C50.4925 177.34 51.7753 179.658 52.6111 181.861C53.0649 183.057 53.4528 185.045 54.25 186.042C54.3897 186.216 54.4666 185.65 54.5556 185.444C54.8912 184.67 55.2308 183.893 55.6111 183.139C56.8552 180.674 58.2746 178.312 59.4444 175.806C61.369 171.681 63.2084 167.502 65.0972 163.375C66.7428 159.779 69.0111 156.394 70.5 152.75C73.0352 146.545 75.4225 140.196 78.3333 134.181C79.0427 132.714 79.5944 131.179 80.4444 129.806C80.941 129.003 81.2129 127.757 82 127.167C82.1809 127.031 82.2987 128.315 82.3056 128.361C82.5034 129.697 82.415 131.067 82.7639 132.375C83.623 135.597 83.3658 138.925 83.8889 142.194C84.3748 145.232 83.8302 148.42 84.125 151.486C84.4353 154.713 84.25 158.009 84.25 161.25C84.25 171.604 84.5519 182.048 86.25 192.236C87.0964 197.315 87.7275 202.409 88.4444 207.5C88.7462 209.643 89 211.836 89 214C89 214.598 88.9545 216.977 89.5 217.25M148.5 217.25C148.5 216.076 148.234 214.922 148.25 213.75C148.279 211.589 148.724 209.331 148.875 207.153C149.277 201.367 149.5 195.679 149.5 189.875C149.5 185.238 148.479 180.603 147.861 176.014C147.28 171.696 146.217 167.379 145.361 163.097C144.803 160.308 143.424 158.014 140.639 157.194C137.524 156.278 133.442 156.083 130.306 156.944C124.436 158.556 120.51 163.734 117.5 168.639C113.339 175.418 110.317 182.584 109.25 190.5C108.979 192.51 108.727 194.469 108.75 196.5C108.774 198.597 109.505 200.55 110.139 202.528C111.151 205.687 112.206 210.478 115.5 212.125C116.541 212.645 117.528 212.509 118.694 212.5C121.071 212.482 123.781 212.258 125.736 210.722C127.567 209.283 129.294 207.812 131.194 206.444C133.618 204.701 135.068 202.118 136.625 199.639C138.474 196.695 140.373 193.847 141.806 190.694C142.649 188.84 143.725 187.229 144.361 185.264C144.741 184.089 145.055 182.821 145.556 181.694C146.098 180.475 147.173 179.387 147.25 178C147.299 177.113 147.118 176.263 147.5 175.5M170.75 116.25C169.786 116.491 170.25 123.711 170.25 124.736C170.25 129.375 171.238 133.991 171.944 138.556C172.359 141.232 172.524 143.942 172.889 146.625C173.324 149.829 174.01 153.005 174.347 156.222C174.663 159.242 174.342 162.284 174.611 165.306C174.901 168.557 175.144 171.739 175.306 175C175.601 180.955 175.145 186.985 175.75 192.917C176.047 195.824 176.5 198.638 176.5 201.556V212.583C176.5 213.263 176.083 216.417 176.75 216.75M233.25 215.25C233.553 211.921 234.149 208.625 234.361 205.25C234.81 198.091 234.611 190.97 234.764 183.806C234.86 179.275 235.305 174.968 234.25 170.514C233.81 168.656 233.308 166.775 232.236 165.167C231.296 163.756 230.036 162.587 229 161.25C227.637 159.491 226.008 157.775 223.694 157.556C219.846 157.191 216.531 158.799 213.486 161.014C209.094 164.208 205.618 168.491 202.694 173.056C199.821 177.542 198.399 182.493 196.875 187.528C195.308 192.705 194.637 198.561 194.514 203.958C194.456 206.488 193.822 210.212 195.75 212.25C197.098 213.675 197.804 214.244 199.806 214.444C203.657 214.83 206.901 212.943 210 210.861C213.567 208.465 215.974 205.311 218.611 202C219.823 200.478 220.978 198.947 222.25 197.472C224.021 195.418 224.742 193.011 226 190.667C228.206 186.557 231.277 183.093 232.972 178.667C233.527 177.218 233.874 175.505 234.25 174M257 161.5C257.227 164.457 258.446 167.21 258.944 170.111C259.602 173.936 260.101 177.839 260.514 181.694C261.42 190.149 262.497 198.528 263.847 206.931C264.099 208.499 263.744 210.175 264.194 211.694C264.257 211.906 264.25 212.349 264.25 211.75C264.25 210.014 264.341 208.27 264.514 206.542C264.954 202.14 266.122 197.618 267.444 193.417C268.401 190.376 268.8 187.18 269.625 184.097C270.574 180.55 270.737 177.114 272.111 173.653C273.106 171.146 273.25 168.358 274.25 165.917C275.211 163.57 276.261 160.185 279.194 160.25C280.999 160.29 283.323 162.135 284.722 163.139C287.144 164.876 287.752 168.056 288.5 170.75C290.313 177.277 290.5 184.019 290.5 190.75V200.278M290.5 200.278V200.625C290.5 201.19 290.499 200.303 290.5 200.278ZM290.5 200.278C290.56 198.062 291.143 195.939 291.694 193.806C292.91 189.106 294.699 184.36 295.236 179.528C295.903 173.522 298.557 167.994 300.986 162.528C302.307 159.556 305.674 159.5 308.722 159.5C312.087 159.5 312.883 163.993 313.25 166.5C314.11 172.379 313.75 178.622 313.75 184.556C313.75 186.936 314 189.288 314 191.667C314 194.276 313.883 196.906 314.194 199.5C314.68 203.544 315.991 207.477 317.5 211.25"
                stroke="black" strokeWidth="9" strokeLinecap="round" />
            </svg>
          </Link>


          <div className="relative group mr-8 mt-6 min-[768px]:hidden">
            <button onClick={toggleDropdown} onMouseEnter={showDropdown} className="flex items-center pl-4 py-2 text-sm text-gray-700 rounded-md focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-transparent">
              <img className="w-8" src={`${process.env.PUBLIC_URL}/menuIcon.svg`} alt="" />
            </button>
            {isDropdownOpen && (
              <div onMouseLeave={hideDropdown} className="absolute hidden group-hover:block z-10 w-52 py-1 mt-0 bg-white border border-gray-200 rounded-md right-0">
                <a href="/#biography"><div className='flex flex-row items-center font-opensans mx-4 my-4'>Biography</div></a>
                <Link to="/books"><div className='flex flex-row items-center font-opensans mx-4 my-4'>Books</div></Link>
                <Link to="/malamfamilyhistory"><div className='flex flex-row items-center font-opensans mx-4 my-4'>Malam Family History</div></Link>
                <Link to="/malamfamilyhistory"><div className='flex flex-row items-center font-opensans mx-4 my-4 pl-6'>&bull; Origins</div></Link>
                <Link to="/familytree"><div className='flex flex-row items-center font-opensans mx-4 my-4 pl-6'>&bull; Family Tree</div></Link>
                <Link to="/edwardmalam"><div className='flex flex-row items-center font-opensans mx-4 my-4 pl-6'>&bull; Edward Malam</div></Link>
                <Link to="/contact"><div className='flex flex-row items-center font-opensans mx-4 my-4'>Contact</div></Link>
              </div>
            )}
          </div>
        </div>

        <div className='flex flex-col font-opensans text-left max-[768px]:m-6 min-[768px]:m-10 max-w-[800px]'>


          <p className='mb-4'><b>If you're here, maybe it's because you too are a Malam, or perhaps you're researching your family tree which has a Malam branch (or twig) on it. </b></p>

          <p className='mb-4'>I've been researching my paternal <b>Malam</b> line for many years, and have also delved into my maternal <b>Lewis/Burns</b> line, with its roots in the metal-bashing trades of the Black Country, south Staffordshire. Both my trees are publicly available on www.ancestry.co.uk and www.findmypast.co.uk, but this page is the place to read some of the <b>Malam</b> stories I've discovered.</p>

          <h2 className='font-bold text-2xl mt-4 mb-2'>Malam &mdash; how do you say it?</h2>
          <p className='mb-4'>I've had a lifetime of hearing and seeing our family name mispronounced and misspelled. I guess my ancestors had the same and, like me, just got used to it.</p>

          <p className='mb-4'>In my family, our uncommon &mdash; rare &mdash; English surname is pronounced with a soft first vowel:</p>

          <ul>
            <li>MAY-lam</li>
            <li className="list-none italic">not</li>
            <li>MAL-am</li>
          </ul>

          <p className='mb-4'>I've been contacted by Malams from all over the world, and we all pronounce the name this way &mdash; it's only non-Malams who seem to have difficulty saying it!</p>

          <p className='mb-4'>And it's a palindrome &mdash; one of the few English surnames that can be spelled the same way forwards and backwards. You'd think that would make it memorable and therefore easy to spell. After all, it only has five letters in it, two of which are repeated. But, no. It's frequently misspelled &mdash; Malham, Mallam, Mallum, Malim being some of the many imposters that have found their way through the Malam letterbox over the years.</p>

          <section className="malham-origin-section">
          <h2 className='font-bold text-2xl mt-4 mb-2'>Malam &mdash; where's it from?</h2>

          <figure className="malham-location-figure">
            <img
              src={`${process.env.PUBLIC_URL}/gallery/malham-location.png`}
              alt="Map showing the location of Malham in North Yorkshire, England"
            />
            <figcaption>Location of Malham, North Yorkshire</figcaption>
          </figure>

          <p className='mb-4'>Malam is included in <i>The Oxford Dictionary of Family Names in Britain and Ireland</i> (Hanks, Coates & McClure, Oxford University Press, 2016), the definitive reference work of 45,000 family names of the UK, where it is described as <b>a locative name &mdash; a name derived from a place-name.</b></p>

          <p className='mb-4'>The <i>Dictionary</i> identifies Malam as a <b>variant spelling of Malham</b>, along with Maleham, Mallam, Mallom, Maylam, and Maugham.</p>

          <p className='mb-4'>As a place-name, Malham is both a village and a civil parish located in North Yorkshire (prior to boundary changes in the 1970s, it was in the historic West Riding of Yorkshire).</p>

          <p className='mb-4'>Early spellings of the Malham place-name are:</p>

          <ul>
            <li>Malgum &mdash; 1086 Domesday Book</li>
            <li>Malhum / Malhom &mdash; 12th century</li>
            <li>Malum &mdash; 13th century</li>
            <li>Mallum &mdash; 14th century</li>
            <li>Mallom / Mallam &mdash; 15th century</li>
            <li>Malham &mdash; 16th century</li>
          </ul>
          </section>


          <h2 className='font-bold text-2xl mt-4 mb-2'>Malam &mdash; what does it mean?</h2>

          <p className='mb-4'>The English Place-Name Society identifies Malham as of Scandinavian (Old Norse) origin, related to the Swedish lake-name Maljen and its earlier form Malghe, proper names derived from <i>malg</i> and <i>maligr</i>, meaning “gravelly”.
          </p>

          <p className='mb-4'>The root meaning of Malham can, therefore, be interpreted as <b>“settlement by the gravelly place”</b>. Those who lived there were identified with their location, and in time, the place-name became a family name. He or she was “John” or “Mary of the gravelly place”, and that was enough to identify and locate them. </p>


          <h2 className='font-bold text-2xl mt-4 mb-2'>Early bearers of the family name and variant spellings</h2>

          <div className="early-bearer-timeline">
            <div className="early-bearer-header">
              {earlyBearerColumns.slice(1).map((column) => (
                <span className={`early-bearer-header-${column.key}`} key={column.key}>
                  {column.label}
                </span>
              ))}
            </div>

            {earlyBearerRows.map((row) => (
              <section className="early-bearer-period" key={row.period}>
                <h3 className="early-bearer-period-label">{row.period}</h3>
                <div className="early-bearer-period-grid">
                  {earlyBearerColumns.slice(1).map((column) => {
                    const names = row[column.key];
                    return (
                      <div
                        className={`early-bearer-column origins-table-${column.key}${names.length === 0 ? ' early-bearer-column-empty' : ''}`}
                        key={column.key}
                      >
                        <span className="early-bearer-mobile-label">{column.label}</span>
                        {names.length > 0 && (
                          <div className="origins-name-list">
                            {names.map((name) => (
                              <span key={name}>{name}</span>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </section>
            ))}
          </div>


          <h2 className='font-bold text-2xl mt-4 mb-2'>Malam &mdash; the Cheshire connection</h2>
          <p>My branch of the Malam tree is firmly rooted in Cheshire, where I live today, and where generations of my
            ancestors have lived.</p>

          <p>I am reasonably confident I can trance my direct paternal line back to George Malim, c.1720&mdash;1778.</p>





          <figure id="chart" className="incidence-chart-card">
            <div className="incidence-chart-header">
              <div>
                <h3 className='font-bold text-xl mt-4 mb-2'>Incidence of Malam name in Findmypast census data {censusYearRange}</h3>
                <p>Exact surname entries by census year, with county incidence shown as stacked segments.</p>
              </div>
              <dl className="incidence-chart-summary">
                <div>
                  <dt>Peak</dt>
                  <dd>{censusTotals[censusPeakIndex]} <span>{censusYears[censusPeakIndex]}</span></dd>
                </div>
                <div>
                  <dt>Growth</dt>
                  <dd>+{censusIncrease} <span>{censusYearRange}</span></dd>
                </div>
              </dl>
            </div>

            <div className="incidence-legend" aria-label="Chart legend">
              {censusSeries.map((series) => (
                <span key={series.name}>
                  <i style={{ backgroundColor: series.color }} aria-hidden="true" />
                  {series.name}
                </span>
              ))}
            </div>

            <div
              className="incidence-chart-plot"
              role="img"
              aria-label={`Stacked bar chart showing incidence of the Malam name in Findmypast census data from ${censusYears[0]} to ${censusYears[censusYears.length - 1]}.`}
            >
              <div className="incidence-chart-scale" aria-hidden="true">
                {censusChartTicks.map((tick) => (
                  <span key={tick} style={{ bottom: `${(tick / censusChartMax) * 100}%` }}>
                    {tick}
                  </span>
                ))}
              </div>

              <div className="incidence-gridlines" aria-hidden="true">
                {censusChartTicks.map((tick) => (
                  <span key={tick} style={{ bottom: `${(tick / censusChartMax) * 100}%` }} />
                ))}
              </div>

              <div className="incidence-bars" style={{ '--incidence-year-count': censusYears.length }}>
                {censusYears.map((year, yearIndex) => (
                  <div className="incidence-bar-group" key={year}>
                    <div className="incidence-bar-stack">
                      <span className="incidence-total">{censusTotals[yearIndex]}</span>
                      <div
                        className="incidence-bar"
                        aria-label={`${year}: ${censusTotals[yearIndex]} total Malam entries`}
                        style={{ '--bar-height': `${(censusTotals[yearIndex] / censusChartMax) * 100}%` }}
                      >
                        {censusSeries.map((series) => {
                          const value = series.values[yearIndex];

                          if (value === 0) {
                            return null;
                          }

                          return (
                            <span
                              key={series.name}
                              tabIndex="0"
                              role="img"
                              aria-label={`${year}, ${series.name}: ${value}`}
                              className="incidence-segment"
                              style={{
                                '--segment-height': `${(value / censusTotals[yearIndex]) * 100}%`,
                                '--segment-color': series.color,
                                '--segment-delay': `${(yearIndex * 65) + (censusSeries.indexOf(series) * 35)}ms`,
                              }}
                              title={`${year}, ${series.name}: ${value}`}
                            >
                              <span className="sr-only">{`${year}, ${series.name}: ${value}`}</span>
                              <span className="incidence-tooltip" role="tooltip">
                                <strong>{series.name}</strong>
                                <span>{value}</span>
                                <em>{year}</em>
                              </span>
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    <span className="incidence-year">{year}</span>
                  </div>
                ))}
              </div>
            </div>

            <figcaption className="sourceCredit">
              <p className="mb-4 text-xs">Source: <a className="underline" target="_blank" rel="noreferrer" href="https://www.findmypast.co.uk/search/results?lastname=malam">Findmypast exact surname search results</a> for Malam in 1841&mdash;1921 census datasets.<br/>Yorkshire uses Findmypast place-keyword matches.</p>
            </figcaption>
          </figure>


        </div>
      </div>

        </div>
      </div>
    </ContentLayout>
  );
}

export default MalamFamilyHistory;
